import {FieldLabel, Grid, GridCell, Range, Div,} from "@bdfx/mergado-ui-kit";
import TransparentColor from "shape-edit/forms/transparent-color";
import {NumericInput} from "shape-edit/forms/fields";
import React from "react";
import {StyledToggler} from "shape-edit/forms/common-shape-form";
import trans from "trans"
import store from "store";
import {initForm} from "app/reducers/form";

export const ProductImageShadow = ({form, formName, props}) => {
    const isShadow = form.shadow_color && form.shadow_sigma

    return <>
        <StyledToggler
            onLabel={trans('drop_shadow')}
            value={!!isShadow}
            onChange={(e) => {
                if (e) {
                    const updatedTemplateForm = {...form,
                        shadow_color: '#3a3a3a',
                        shadow_sigma: 5,
                        shadow_xoffset: 10,
                        shadow_yoffset: 10,
                        shadow_opacity: 80,
                    }
                    store.dispatch(initForm(formName, updatedTemplateForm))
                } else {
                    const updatedTemplateForm = {...form,
                        shadow_color: null,
                        shadow_sigma: null,
                        shadow_xoffset: null,
                        shadow_yoffset: null,
                        shadow_opacity: 100,
                    }
                    store.dispatch(initForm(formName, updatedTemplateForm))
                }
            }}
        />

        {isShadow ?
            <Div padding="0 20px">
                <TransparentColor
                    label={trans('shadow_color')}
                    name={`${formName}.shadow_color`}
                    value={form.shadow_color}
                    changeValue={(color) => {
                        props.change(formName, `shadow_color`, color)
                    }}
                />

                <Range
                    label={<>{trans('shadow_opacity')}</>}
                    min={0}
                    max={100}
                    step={1}
                    name={`${formName}.shadow_opacity`}
                    placeholder={trans('shadow_opacity')}
                />

                <Range
                    label={trans('shadow_sigma')}
                    min={2}
                    max={100}
                    step={1}
                    onChange={(e) => props.change(formName, `shadow_sigma`, e)}
                    value={Math.round(form.shadow_sigma || 2)}
                    placeholder={trans('shadow_sigma')}
                />

                <div>
                    <FieldLabel>{trans("angle")}</FieldLabel>
                    <Range
                        min={0}
                        max={360}
                        step={10}
                        onChange={(value) => {
                            const R = Math.round(Math.sqrt(form.shadow_yoffset**2+form.shadow_xoffset**2))
                            const alpha = value/180*Math.PI
                            const updatedTemplateForm = {...form,
                                shadow_xoffset: R*Math.cos(alpha),
                                shadow_yoffset: R*Math.sin(alpha),
                            }
                            store.dispatch(initForm(formName, updatedTemplateForm))
                        }}
                        value={Math.round(Math.atan2(form.shadow_yoffset, form.shadow_xoffset)*180/Math.PI+360)%360}
                        placeholder={trans('angle')}
                    />


                    <FieldLabel>{trans("shadow_offset")}</FieldLabel>
                    <Grid cols={'1fr 1fr'} gap="20px">
                        <GridCell style={{position: "relative"}}>
                            <NumericInput
                                formName={formName}
                                fieldName={'shadow_xoffset'}
                                placeholder={'shadow_xoffset'}
                                id={'shadow-xoffset-input'}
                                min={0}
                                step={5}
                                units={'px'}
                                value={Math.round(form.shadow_xoffset)}
                            />
                        </GridCell>
                        <GridCell style={{position: "relative"}}>
                            <NumericInput
                                formName={formName}
                                fieldName={'shadow_yoffset'}
                                placeholder={'shadow_yoffset'}
                                id={'shadow-yoffset-input'}
                                min={0}
                                step={5}
                                units={'px'}
                                value={Math.round(form.shadow_yoffset)}
                            />
                        </GridCell>
                    </Grid>
                </div>
            </Div> :
            null
        }
    </>
}

export const ProductImageReflection = ({form, formName}) => {
    return <>
        <StyledToggler
            onLabel={trans('has_reflection')}
            value={!!form.has_reflection}
            onChange={(e) => {
                if (e) {
                    const updatedTemplateForm = {...form,
                        has_reflection: true,
                        reflection_angle: 0,
                        reflection_offset: 0,
                        reflection_opacity: 50,
                    }
                    store.dispatch(initForm(formName, updatedTemplateForm))
                } else {
                    const updatedTemplateForm = {...form,
                        has_reflection: null,
                        reflection_angle: null,
                        reflection_offset: null,
                        reflection_opacity: null,
                    }
                    store.dispatch(initForm(formName, updatedTemplateForm))
                }
            }}
        />

        {form.has_reflection ?
            <Div padding="0 20px">
                <Range
                    label={trans('reflection_angle')}
                    min={-90}
                    max={90}
                    step={1}
                    name={`${formName}.reflection_angle`}
                    placeholder={trans('reflection_angle')}
                />

                <Range
                    label={trans('reflection_offset')}
                    min={-100}
                    step={10}
                    name={`${formName}.reflection_offset`}
                    placeholder={trans('reflection_offset')}
                />

                <Range
                    label={trans('reflection_opacity')}
                    min={0}
                    max={100}
                    step={1}
                    name={`${formName}.reflection_opacity`}
                    placeholder={trans('reflection_opacity')}
                />
            </Div> :
            null
        }
    </>
}